import ForecastService from "../../services/forecastService";
import appForecastUtils from "../../utils/appForecast.utils";
import { stat } from "fs";

const state = {
	forecastAnalytics: {},
	basicsStore: "region",
	num_periodStore: 7,
	aggregateStore: "week",
	periodStore: "1 week",
	queryObjectDate: {},
	outlet: {},
	queryParams: {},
	product: {},
	forecastFromDate: "",
	forecastToDate: "",
	forecastChartData: "[]",
	forecastTableLoader: false,
	forecastGraphLoader: false
};
const mutations = {
	FORECAST_ANALYTICS: (state, payload) => {
		state.forecastAnalytics = payload;
	},
	BASICS_STORE: (state, payload) => {
		state.basicsStore = payload;
	},
	NUM_PERIOD_STORE: (state, payload) => {
		state.num_periodStore = payload;
	},
	AGGREGATE_STORE: (state, payload) => {
		state.aggregateStore = payload;
	},
	PERIOD_STORE: (state, payload) => {
		state.periodStore = payload;
	},
	QUERY_OBJECT_DATE: (state, payload) => {
		state.queryObjectDate = payload;
	},
	OUTLET: (state, payload) => {
		state.outlet = payload;
	},
	PRODUCT: (state, payload) => {
		state.product = payload;
	},
	UPDATE_FROM_DATE: (state, payload) => {
		state.forecastFromDate = payload;
	},
	UPDATE_TO_DATE: (state, payload) => {
		state.forecastToDate = payload;
	},
	UPDATE_FORECAST_DATA: (state, payload) => {
		state.forecastChartData = payload;
	},
	UPDATE_FORECAST_TABLE_LOADER: (state, payload) => {
		state.forecastTableLoader = payload;
	},
	UPDATE_FORECAST_GRAPH_LOADER: (state, payload) => {
		state.forecastGraphLoader = payload;
	}
};
const actions = {
	fetchForecast({ commit }, payload) {
		commit("UPDATE_FORECAST_TABLE_LOADER", true);
		// console.log("page in fo in fetchForecast", payload.pageInfo);
		return ForecastService.forecastQuery(payload.queryObject, payload.pageInfo)
			.then(response => {
				commit(
					"CommonStore/TABLE_PAGE_COUNT",
					JSON.parse(response.data).count,
					{ root: true }
				);
				// console.log("response of forecast", JSON.parse(response.data));
				return JSON.parse(response.data).results;
				// appForecastUtils.postFetchForecast(response);
				// commit("SET_FORECAST_ANALYTICS", response);
			})
			.catch(error => {
				console.error(error);
			}).finally(res => {
				commit("UPDATE_FORECAST_TABLE_LOADER", false);
			});
	},
	setForecastAnalytics({ commit }, payload) {
		commit("FORECAST_ANALYTICS", payload);
	}
};

export default {
	state,
	mutations,
	actions,
	namespaced: true
};
